import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { RadioButton } from 'react-native-paper';
import { Colors } from '../constants/Colors';
import { TextReg } from './StyledText';

type RadioOption = {
  label: string;
  value: string;
};

type Props = {
  options: RadioOption[];
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
};

export function RadioGroup({
  options,
  value,
  onValueChange,
  disabled = false,
}: Props) {
  return (
    <RadioButton.Group onValueChange={onValueChange} value={value}>
      <View style={styles.container}>
        {options.map((option) => (
          <TouchableOpacity
            key={option.value}
            style={styles.radioItem}
            onPress={() => {
              if (disabled) return;
              onValueChange(option.value);
            }}
            disabled={disabled}
            activeOpacity={0.7}
          >
            <RadioButton.Android
              value={option.value}
              color={Colors.purple1}
              uncheckedColor={Colors.opacity40}
              disabled={disabled}
            />
            <TextReg
              style={[
                styles.label,
                value === option.value && styles.selectedLabel,
                disabled && styles.disabledLabel,
              ]}
            >
              {option.label}
            </TextReg>
          </TouchableOpacity>
        ))}
      </View>
    </RadioButton.Group>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  radioItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontSize: 14,
    color: Colors.text,
    opacity: 0.8,
  },
  selectedLabel: {
    opacity: 1,
    fontWeight: '600',
    color: Colors.purple1,
  },
  disabledLabel: {
    opacity: 0.4,
  },
});
